import React from "react";
import { Fragment } from "react";
import { useEffect } from "react";
import { useState } from "react";
import Head from "../../layout/Head";
import Header from "../Shear/Header/Header";
import Footer from "../Shear/Footer/Footer";

const OtpBox = () => {
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    let interval = null;
    if (seconds > 1) {
      interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else {
      setSeconds(60);
    }

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    const result = Object.fromEntries(data.entries());

    const OtpCode = ` ${result.num1}${result.num2}${result.num3}${result.num4} `;
    console.log(OtpCode);
  };

  return (
    <Fragment>
      <Head
        Title="Verification"
        href="/verification"
        description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | Register Pages"
      />
      <Header title="Verification" />
      <div>
        <div className="relative flex min-h-screen flex-col justify-center overflow-hidden bg-gray-50 py-12">
          <div className="relative bg-[#fff] px-6 pt-10 pb-9 shadow-xl mx-auto w-full max-w-lg rounded-2xl">
            <div className="mx-auto flex w-full max-w-md flex-col space-y-16">
              <div className="flex flex-col items-center justify-center text-center space-y-2">
                <div className="font-semibold text-3xl">
                  <p>Email Verification </p>
                </div>
                <div className="flex flex-row text-sm font-medium text-[#a7a7a7]">
                  <p>
                    Check your email{" "}
                    <strong className="text-[#000]"> {seconds} Seconds</strong>
                  </p>
                </div>
              </div>

              <div>
                <form onSubmit={onSubmitHandler}>
                  <div className="flex flex-col space-y-16">
                    <div className="flex flex-row items-center justify-between mx-auto w-full max-w-xs">
                      <div className="w-16 h-16 ">
                        <input
                          className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-[#dedede]  text-lg bg-[#fff] focus:bg-gray-50 focus:ring-1 ring-blue-700"
                          type="text"
                          name="num1"
                          required
                          id="number"
                        />
                      </div>
                      <div className="w-16 h-16 ">
                        <input
                          className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-[#dedede]  text-lg bg-[#fff] focus:bg-gray-50 focus:ring-1 ring-blue-700"
                          type="text"
                          name="num2"
                          required
                          id="number"
                        />
                      </div>
                      <div className="w-16 h-16 ">
                        <input
                          className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-[#dedede]  text-lg bg-[#fff] focus:bg-gray-50 focus:ring-1 ring-blue-700"
                          type="text"
                          name="num3"
                          required
                          id="number"
                        />
                      </div>
                      <div className="w-16 h-16 ">
                        <input
                          className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-[#dedede]  text-lg bg-[#fff] focus:bg-gray-50 focus:ring-1 ring-blue-700"
                          type="text"
                          name="num4"
                          required
                          id="number"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col space-y-5">
                      <div>
                        <button
                          type="submit"
                          className="flex flex-row items-center justify-center text-center w-full border rounded-xl outline-none py-5  bg-primary text-[#fff] border-none text-white text-sm shadow-sm"
                        >
                          Verify Account
                        </button>
                      </div>

                      <div className="flex flex-row items-center justify-center text-center text-sm font-medium space-x-1 text-[#979797]">
                        <p>Didn't recieve code?</p>{" "}
                        <a
                          className="flex flex-row items-center text-linear-gradient "
                          href="http://"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Resend
                        </a>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};

export default OtpBox;
